import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement, useCallback } from "react";
import { Icon } from "../Icon/Icon";
import styles from "./SelectionCheckbox.module.less";

export type SelectAllCheckboxValue = true | false | "mixed";

export type SelectAllCheckboxProps = {
	value: SelectAllCheckboxValue;
	isDisabled?: boolean;
	trackingId: string;
	onChange: (value: boolean) => void;
};

export const SelectAllCheckbox = (props: SelectAllCheckboxProps): ReactElement => {
	const {
		value,
		onChange,
		isDisabled,
		trackingId
	} = props;

	const changeHandler = useCallback(
		(): void => {
			if (isDisabled) {
				return;
			}

			if (value === "mixed") {
				onChange(false);
			} else {
				onChange(!value);
			}

		},
		[
			isDisabled,
			onChange,
			value
		]
	);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={
				classNames(
					styles.root,
					{
						[styles.root_disabled]: isDisabled
					}
				)
			}
			onClick={changeHandler}
			role="checkbox"
			aria-checked={value}
			aria-disabled={isDisabled}
			tabIndex={0}
		>
			<span className={styles.glyph}>
				{value !== false && (
					<Icon
						size="medium"
						value={value === "mixed" ? "minus" : "check"}
					/>
				)}
			</span>
		</div>
	);
};
SelectAllCheckbox.displayName="SelectAllCheckbox";